export class ListPagingSetPageNumberAction {
  constructor(public pageNumber: number) {
  }
}
